import { DeviceColumns } from '../enum/DeviceColumns';
import { Games } from '../enum/Games';
import { GeoColumns } from '../enum/GeoDivisionColumnName';
import { PaymentSource } from '../enum/PaymentSource';
import { PaymentType, PaymentTypeColumn } from '../enum/PaymentType';
import { StatsTableColumn } from '../enum/TableColumn';
import { CashRegisterItem } from '../interface/response/CashRegisterDataResponse';
import { Stats } from '../interface/stats/StatsResponse';

export const FIRST_PAGE = 0;

// INTERVALS (ms)
export const INTERVAL_SCREENSHOT_REFRESH = 30000;
export const INTERVAL_GENERATE_END_TIME_SLOT_FOR_TODAY = 50000;
export const INTERVAL_ONE_SECOND = 1000;
export const INTERVAL_GET_DEVICE_LOGS = 15000;
export const INTERVAL_GET_DEVICE_STATUS = 15000;
export const INTERVAL_REFRESH_DEVICE_LIST = 300000;

// TIMEOUTS (ms)
export const TIMEOUT_AUTOCOMPLETE_SEARCH = 200;
export const TIMEOUT_HM_MODAL_MESSAGE = 1700;

export const MOBILE_TABLET_BREAKPOINT = 1024;
export const MOBILE_MENU_DISAPPEAR_TIMEOUT = 300;

// DATEPICKER
export const DATE_PICKER_CLOSE = 250;
export const DATE_PICKER_VISIBLE = 10;
export const LAST_SEVEN_DAYS = 6;
export const LAST_THIRTY_DAYS = 29;
export const LAST_NINETY_DAYS = 89;
export const HOURS_IN_DAY_MINUS_ONE = 23;
export const HOURS_IN_DAY = 24;
export const MINUTES_IN_HOUR_MINUS_ONE = 59;
export const MILISECUONDS_IN_MINUTE = 999;

export const MOBILE_BREAKPOINT = 768;

export const DELAY_TOUCH_START = 200;

export const HEADER_HEIGHT = 49;

// Auto-width measurement for number_column table columns (see useNumberColumnWidth)
export const TABLE_HEADER_FONT = '700 14px Inter';
export const TABLE_BODY_FONT = '500 14px Inter';
// header_cell_content padding (16px + 8px) + border-right (1px) + sort icon/gap allowance (20px)
export const TABLE_HEADER_EXTRA_WIDTH = 16 + 8 + 1 + 20;
// table_cell padding (8px + 8px) + border-right (1px)
export const TABLE_BODY_EXTRA_WIDTH = 8 + 8 + 1;

export const ANIMATION_DURATION_MS = 450;

// Payment Sources
export const PAYMENT_OPTIONS = [
  { ID: 1, Name: 'OTC' },
  { ID: 2, Name: 'SSBT' },
  { ID: 3, Name: 'eSSBT' },
  { ID: 10, Name: 'Android' },
  { ID: 20, Name: 'Online' },
  { ID: 100, Name: 'Partner' },
];

// Payment Types
export const PAYMENT_TYPE_OPTIONS = [
  { ID: 0, Name: 'statisticPage.header.filter.paymentType.cash' },
  { ID: 1, Name: 'statisticPage.header.filter.paymentType.card' },
  { ID: 2, Name: 'statisticPage.header.filter.paymentType.freebet' },
];

export const DIGITS_ONLY_REGEX = /^\d*$/;
export const DECIMAL_NUMBERS_REGEX = /^\d*\.?\d*$/;

export const CURRENCY_BORDER_COLOR = 'var(--footer-sum-border)';
export const CURRENCY_LIST_BORDER_COLOR = 'var(--footer-sum-list-border)';
export const DEFAULT_TIMEZONE = 'Etc/UTC';
export const BASE_COLUMN_CLASS = {
  STICKY: 'sticky_column',
  NORMAL: 'column',
};

export const COLUMN_MAP: Record<string, string> = {
  GroupName: 'Group',
  LocationName: 'Location',
  DeviceName: 'Device',
  Currency: 'CCY',
};

export const HIDDEN_COLUMNS = ['PaymentSource', 'GroupID', 'LocationID', 'DeviceID', 'NumberOfTickets', 'GameTypeEnum'];

export const SEARCHABLE_STATISTICS_FIELDS: (keyof Stats)[] = [
  'Client',
  'Company',
  'Region',
  'Group',
  'Location',
  'CCY',
  'Device',
  'DeviceTypeEnum',
  'PaymentTypeEnum',
];

export const DEFAULT_VISIBLE_GEO_COLUMNS = [GeoColumns.GROUP, GeoColumns.LOCATION];
export const DEFAULT_UNVISIBLE_COLUMNS = [
  StatsTableColumn.BET_AFTER_TAX,
  StatsTableColumn.BET_TAX,
  StatsTableColumn.FOR_PAYOUT_AFTER_TAX,
  StatsTableColumn.FOR_PAYOUT_TAX,
  StatsTableColumn.PAYOUT_AFTER_TAX,
  StatsTableColumn.PAYOUT_TAX,
  StatsTableColumn.WIN_AFTER_TAX,
  StatsTableColumn.WIN_TAX,
];
export const SEARCHABLE_CASHREGISTER_FIELDS: (keyof CashRegisterItem)[] = ['LocationName', 'DeviceName', 'GroupName'];

export const PLURALIZED_COLUMNS = [PaymentSource.PAYMENT_SOURCE, Games.GAMES, PaymentType.PAYMENT_TYPE];

export const ItemTypes = {
  COLUMN: 'column',
};

export const EXCEL = '.xls';
export const PDF = '.pdf';

export const SEARCH_INPUT_DEBOUNCE_DELAY = 400;

export const MIN_THUMB_SIZE = 20;

export const NUMBER_FORMAT_LOCALES = {
  US: 'en-US',
  EU: 'de-DE',
};

export const US = 'US';
export const EU = 'EU';
export const US_NUMBER_FORMAT = '1,000.00';
export const EU_NUMBER_FORMAT = '1.000,00';

export const STATISTIC_PAGE = 'stats';
export const CASH_REGISTER_PAGE = 'cashRegister';

export const FILTER_DEPENDENT_COLUMNS = new Set<string>([
  DeviceColumns.DEVICE,
  DeviceColumns.DEVICE_TYPE_ENUM,
  PaymentTypeColumn.PAYMENT_TYPE,
]);

// Graph points
export const LIVE_DATA_POINTS = 9;
export const STATIC_DATA_POINTS_DESKTOP = 30;
export const STATIC_DATA_POINTS_MOBILE = 15;

export const ACCESS_TOKEN_CHANGED_EVENT = 'accessTokenChanged';
